export default __webpack_public_path__ + "static/media/logo-white.ebd85583.svg";